// extracted by mini-css-extract-plugin
export default {"loadingScreen":"LoadingScreen_loadingScreen__B89QB","logo":"LoadingScreen_logo__UMU1M","pg":"LoadingScreen_pg__YjsvP"};